import React from 'react';
import styles from '../styles';
import googlePlayBadge from '../assets/google-play-badge.png';
import phoneMockup from '../assets/triple-knock.png';
import useMediaQuery from '../hooks/useMediaQuery'; // Import the new hook
import { useLanguage } from '../contexts/LanguageContext';
import WhatsAppButton from './WhatsAppButton';

const Hero = () => {
    const isMobile = useMediaQuery('(max-width: 768px)'); // Use the hook to check for mobile screen size
    const { t } = useLanguage();

    // Define base styles
    const heroStyles = {
        container: {
            ...styles.section,
            paddingTop: '8rem', // Increased top padding
            background: 'linear-gradient(135deg, #FFF5F5 0%, #f8f9fa 55%, #FFFFFF 100%)', // Soft warm gradient
            padding: '8rem 2rem 4rem 2rem',
        },
        contentWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            gap: '4rem',
            maxWidth: '1200px',
            width: '100%',
            flexDirection: isMobile ? 'column' : 'row', // Dynamic direction
            textAlign: isMobile ? 'center' : 'left',
        },
        textContainer: {
            flex: '1 1 50%', // Flex grow, shrink, and basis
            textAlign: 'left',
            paddingRight: isMobile ? '0' : '2rem',
        },
        headline: {
            ...styles.h1,
            fontSize: isMobile ? '2.5rem' : '3.5rem', // Dynamic font size
            lineHeight: '1.2',
            marginBottom: '1.5rem',
        },
        subheading: {
            ...styles.subheading,
            textAlign: isMobile ? 'center' : 'left',
            marginBottom: '2.5rem', // Increased margin
        },
        ctaButton: {
            height: '60px', // A standard height for the badge
        },
        buttonsContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: isMobile ? 'center' : 'flex-start',
            gap: '1rem',
        },
        imageContainer: {
            flex: '1 1 40%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: isMobile ? '0' : '300px', // Ensures the image container doesn't get too small
            marginTop: isMobile ? '2rem' : 0,
        },
        phoneMockup: {
            width: '100%', // Make image responsive
            maxWidth: '380px', // But not larger than the original size
            height: 'auto', // Maintain aspect ratio
            objectFit: 'contain',
        }
    };

    if (isMobile) {
        heroStyles.textContainer.textAlign = 'center';
        heroStyles.subheading.textAlign = 'center';
    }


    return (
        <section style={heroStyles.container}>
            <div style={heroStyles.contentWrapper}>
                <div style={heroStyles.textContainer}>
                    <h1 style={heroStyles.headline}>{t('hero.headline')}</h1>
                    <p style={heroStyles.subheading}>
                        {t('hero.subheading')}
                    </p>
                    <div style={heroStyles.buttonsContainer}>
                        <a href="https://play.google.com/store/apps/details?id=com.retterplus.android" target="_blank" rel="noopener noreferrer">
                            <img src={googlePlayBadge} alt={t('hero.getItOnGooglePlay')} style={heroStyles.ctaButton} />
                        </a>
                        <WhatsAppButton style={{ height: '60px', borderRadius: '8px', padding: '0 1.5rem', fontSize: '1.2rem', marginLeft: 0 }} />
                    </div>
                </div>
                <div style={heroStyles.imageContainer}>
                    {/* Display the actual phone mockup image */}
                    <img src={phoneMockup} alt={t('hero.phoneMockupAlt')} style={heroStyles.phoneMockup} />
                </div>
            </div>
        </section>
    );
};

export default Hero;
